import "./style.scss";
import "./settings.scss";
import "./animate.scss";
import ipad from "../../assets/BrandPage/ipad.png";
import splash1 from "../../assets/BrandPage/splash-1.png";
import splash2 from "../../assets/BrandPage/splash-2.png";
import images from "../../assets/BrandPage";
import Slider from "react-slick";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import BrandingService from "../../services/BrandingService";
import { Helmet } from "react-helmet";
import Blogs from "./Blogs";

const Branding = () => {
	const brandingService = new BrandingService();
	const [formData, setFormData] = useState({
		wwd_description: "",
		services: [],
		banners: [],
		our_partners: [],
	});

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, []);

	useEffect(() => {
		let banners = brandingService?.getBanners();
		// let wwd = brandingService?.getWWD();
		// let services = brandingService?.getServices();
		let images = brandingService?.getImages();

		Promise.all([banners, images]).then((res) => {
			let data = {};
			if (res[0]?.status === 200) {
				const banners = res[0]?.data?.data?.map((info) => {
					return {
						...info,
						src: info?.image,
					};
				});
				data["banners"] = [...banners];
			}

			// if (res[1]?.status === 200) {
			// 	data["wwd_description"] = res[1]?.data?.data?.description;
			// }

			// if (res[2]?.status === 200) {
			// 	data["services"] = res[2]?.data?.data;
			// }

			if (res[1]?.status === 200) {
				data["our_partners"] = res[1]?.data?.data;
			}

			setFormData({ ...formData, ...data });
		});
	}, []);

	const settings = {
		dots: false,
		fade: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		waitForAnimate: false,
		autoplay: true,
		autoplaySpeed: 3000,
	};

	return (
		<>
			<Helmet>
				<meta
					name="description"
					content="Cloud Lift Solutions offers expert branding services in Kuwait, including custom brand identity design, logo design, and strategic brand messaging. Our tailored solutions help businesses create a strong, memorable brand presence."
				/>
				<meta name="keywords" content="Branding Services Kuwait" />
				<title>Branding Services in Kuwait | Cloud Lift Solutions</title>
			</Helmet>
			<div className="branding">
				<Link to="/">
					<img
						src={logo}
						alt="large-logo"
						className="large-icon"
						width="90px"
						style={{ filter: "drop-shadow(0 0 0.05rem #303D57)" }}
					/>
				</Link>
				{!!formData?.banners?.length && (
					<div className="slider-container">
						<Slider {...settings}>
							{formData?.banners?.map((banner, index) => {
								return (
									<div key={banner?.id} style={{ position: "relative" }}>
										{banner?.src?.endsWith(".mp4") ||
										banner?.src?.endsWith(".ogg") ||
										banner?.src?.endsWith(".webm") ? (
											<video className="w-100 h-100" autoPlay controls>
												<source src={banner?.src} type="video/mp4" />
												<source src={banner?.src} type="video/ogg" />
											</video>
										) : (
											<img
												src={banner?.src}
												alt={banner?.id}
												className="w-100"
											/>
										)}

										<div className="titles">
											<p
												className="tp-caption sft sl-title"
												data-x="center"
												data-y="center"
												data-voffset="-90"
												data-speed="700"
												data-start="1700"
												data-easing="easeOutBack">
												{banner?.title}
											</p>
											<p
												className="tp-caption sfb second-title"
												data-x="center"
												data-y="center"
												data-voffset="40"
												data-speed="500"
												data-start="1900"
												data-easing="easeOutBack">
												{banner?.sub_title}
											</p>
										</div>
									</div>
								);
							})}
						</Slider>
						<div className="scroll-down-button">
							<img
								src={images?.downButton}
								className="down-button"
								alt="downButton"
							/>
							<i className="fa fa-angle-down"></i>
						</div>
					</div>
				)}
				<div className="mil-dark-bg py-5">
					<div className="container">
						<div className="pt-5 pb-3 text-center">
							<span className="text-white">Our Services</span>
							<h3 className="title text-white mb-3">What We Do</h3>
							<span className="text-white d-block mb-2">
								At Cloud Lift Solutions
							</span>
							<p className="text-white w-50 m-auto mb-5 description">
								We turn ideas into brand identities that captivate, build
								loyalty& reflect your core value in every interaction
							</p>
							<div className="row">
								<div className="col-md-4 col-12">
									<div className="wwd-card mt-5">
										<svg
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
											<g
												id="SVGRepo_tracerCarrier"
												stroke-linecap="round"
												stroke-linejoin="round"></g>
											<g id="SVGRepo_iconCarrier">
												{" "}
												<path
													d="M10.75 22.5001H13.27C14.23 22.5001 14.85 21.8201 14.67 20.9901L14.26 19.1802H9.75999L9.35 20.9901C9.17 21.7701 9.85 22.5001 10.75 22.5001Z"
													stroke="#FFFFFF"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"></path>{" "}
												<path
													d="M14.26 19.1702L15.99 17.6301C16.96 16.7701 17 16.1701 16.23 15.2001L13.18 11.3302C12.54 10.5202 11.49 10.5202 10.85 11.3302L7.8 15.2001C7.03 16.1701 7.02999 16.8001 8.03999 17.6301L9.77 19.1702"
													stroke="#FFFFFF"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"></path>{" "}
												<path
													d="M12.01 11.1201V13.6501"
													stroke="#FFFFFF"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"></path>{" "}
												<path
													d="M12.52 5H11.52C10.97 5 10.52 4.55 10.52 4V3C10.52 2.45 10.97 2 11.52 2H12.52C13.07 2 13.52 2.45 13.52 3V4C13.52 4.55 13.07 5 12.52 5Z"
													stroke="#FFFFFF"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"></path>{" "}
												<path
													d="M3.27 14.17H4.27C4.82 14.17 5.27 13.72 5.27 13.17V12.17C5.27 11.62 4.82 11.1699 4.27 11.1699H3.27C2.72 11.1699 2.27 11.62 2.27 12.17V13.17C2.27 13.72 2.72 14.17 3.27 14.17Z"
													stroke="#FFFFFF"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"></path>{" "}
												<path
													d="M20.73 14.17H19.73C19.18 14.17 18.73 13.72 18.73 13.17V12.17C18.73 11.62 19.18 11.1699 19.73 11.1699H20.73C21.28 11.1699 21.73 11.62 21.73 12.17V13.17C21.73 13.72 21.28 14.17 20.73 14.17Z"
													stroke="#FFFFFF"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"></path>{" "}
												<path
													d="M10.52 3.56006C6.71 4.01006 3.75 7.24004 3.75 11.17"
													stroke="#FFFFFF"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"></path>{" "}
												<path
													d="M20.25 11.17C20.25 7.25004 17.31 4.03006 13.52 3.56006"
													stroke="#FFFFFF"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"></path>{" "}
											</g>
										</svg>
										<p>Logo & Packaging Design</p>
										<span>
											Distinctive logos and packaging that speak your brand's
											language
										</span>
									</div>
								</div>
								<div className="col-md-4 col-12">
									<div className="wwd-card">
										<svg
											fill="#FFFFFF"
											height="200px"
											width="200px"
											version="1.1"
											id="Layer_1"
											xmlns="http://www.w3.org/2000/svg"
											xlink="http://www.w3.org/1999/xlink"
											viewBox="0 0 496 496"
											space="preserve">
											<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
											<g
												id="SVGRepo_tracerCarrier"
												stroke-linecap="round"
												stroke-linejoin="round"></g>
											<g id="SVGRepo_iconCarrier">
												{" "}
												<g>
													{" "}
													<g>
														{" "}
														<path d="M483.712,424.4L379.312,320l18.344-18.344l-11.312-11.312L368,308.688l-13.936-13.936 c17.576-27.624,28.296-60,29.728-94.752h3.92l29.624,44.44l13.312-8.872L406.944,200h12.768l29.624,44.44l13.312-8.872 L438.944,200h12.768l29.624,44.44l13.312-8.872L465.616,192l29.04-43.56l-13.312-8.872L451.72,184h-12.768l23.712-35.56 l-13.312-8.872L419.72,184h-12.768l23.712-35.56l-13.312-8.872L387.72,184h-3.92C379.584,81.832,295.184,0,192,0 C86.136,0,0,86.136,0,192s86.136,192,192,192c37.784,0,73.016-11.016,102.752-29.936L308.688,368l-18.344,18.344l11.312,11.312 L320,379.312l104.4,104.4c7.92,7.92,18.456,12.288,29.656,12.288C477.184,496,496,477.184,496,454.056 C496,442.856,491.64,432.328,483.712,424.4z M192,368c-97.048,0-176-78.952-176-176S94.952,16,192,16 c94.368,0,171.6,74.656,175.8,168h-24.2C339.392,103.912,273.112,40,192,40c-83.816,0-152,68.184-152,152s68.184,152,152,152 c81.112,0,147.392-63.912,151.592-144h24.2C363.6,293.344,286.368,368,192,368z M210.344,154.344L172.688,192l37.656,37.656 l11.312-11.312L203.312,200h44.048c-3.904,27.096-27.208,48-55.36,48c-30.88,0-56-25.12-56-56s25.12-56,56-56 c28.152,0,51.456,20.904,55.36,48h-44.048l18.344-18.344L210.344,154.344z M192,120c-39.696,0-72,32.304-72,72s32.304,72,72,72 c36.992,0,67.528-28.056,71.528-64h24.064c-4.088,49.192-45.36,88-95.592,88c-52.936,0-96-43.064-96-96c0-52.936,43.064-96,96-96 c50.232,0,91.504,38.808,95.592,88h-24.064C259.528,148.056,228.992,120,192,120z M192,80c-61.76,0-112,50.24-112,112 s50.24,112,112,112c59.056,0,107.464-45.976,111.592-104h24C323.416,271.264,264.288,328,192,328c-74.992,0-136-61.008-136-136 S117.008,56,192,56c72.288,0,131.416,56.736,135.592,128h-24C299.464,125.976,251.056,80,192,80z M308.096,344.784 c13.816-10.52,26.16-22.872,36.688-36.688L356.688,320L320,356.688L308.096,344.784z M454.056,480 c-6.928,0-13.44-2.696-18.344-7.6L331.312,368L368,331.312l104.4,104.4c4.896,4.904,7.6,11.416,7.6,18.344 C480,468.36,468.36,480,454.056,480z"></path>{" "}
													</g>{" "}
												</g>{" "}
											</g>
										</svg>
										<p>Brand Strategy & Messaging</p>
										<span>
											Defining your brand's voice, vision and market position
										</span>
									</div>
								</div>
								<div className="col-md-4 col-12">
									<div className="wwd-card mt-5">
										<svg
											fill="#FFFFFF"
											viewBox="0 0 32 32"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg">
											<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
											<g
												id="SVGRepo_tracerCarrier"
												stroke-linecap="round"
												stroke-linejoin="round"></g>
											<g id="SVGRepo_iconCarrier">
												{" "}
												<title>lamp4</title>{" "}
												<path d="M17.747 14.017c-1.25 0.562-4.022-0.815-4.022-0.815-3.248-1.947 1.22 6.073 1.22 6.073s0.093 2.503 0.655 2.815c4.687-6.563 3.397-8.636 2.147-8.073zM16.060 20.24c-0.379 0-1.972-4.779-1.784-5.779 1.251 0.125 2.409 0.597 3.097 0.222 1.937-0.878-0.876 5.557-1.313 5.557zM19.952 23.947c0.115-7.305 4.046-10.116 4.046-14.466 0-3.712-2.54-8.45-7.87-8.45-5.329 0-8.126 4.533-8.126 8.484 0 4.436 3.993 7.224 3.993 14.478h4.043c0 0 3.798-0.046 3.914-0.046zM12.809 23.020c0-6.771-3.868-9.373-3.868-13.513 0-3.688 2.51-7.556 7.173-7.556s6.948 4.060 6.948 7.524c0 4.060-3.814 6.742-3.916 13.56-0.102 0-3.111-0.016-3.111-0.016h-3.226zM19.505 25.014h-7c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h7c0.275 0 0.5-0.224 0.5-0.5s-0.225-0.5-0.5-0.5zM19.505 27.014h-7c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h7c0.275 0 0.5-0.224 0.5-0.5s-0.225-0.5-0.5-0.5zM12.997 29.043c0 0 0 0.334 0 0.9s0.444 1.025 0.992 1.025h4.031c0.549 0 0.992-0.459 0.992-1.025s-0.062-0.9-0.062-0.9h-5.953z"></path>{" "}
											</g>
										</svg>
										<p>Rebranding & Booth Designing</p>
										<span>
											Revamping your brand identity and design booths that grab
											attention
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="container">
					<Blogs blogs={formData?.our_partners} />
				</div>

				{/* <section className=" about-us padding-section">
					<div className="grid-row">
						<div className="grid-col-row clear">
							<div className="grid-col grid-col-6 col-sd-12">
								<div className="title">
									<span className="main-title">What we do</span>
								</div>
								<p
									className="mb-5"
									style={{ width: "80%" }}
									dangerouslySetInnerHTML={{
										__html: formData?.wwd_description,
									}}></p>
								<Link
									to="/contact-us"
									style={{
										border: "1px solid",
										padding: "8px 16px",
										borderRadius: "8px",
									}}>
									Get Started
								</Link>
							</div>
							<div className="grid-col grid-col-6 content-img col-sd-12">
								<img className="ipad" src={ipad} alt="ipad" />

								<img id="splash-1" src={splash1} alt="splash1" />
								<img id="splash-2" src={splash2} alt="splash2" />
							</div>
						</div>
					</div>
				</section>
				<hr /> 

				<div classNameName="mt-5">
					<div className="grid-row clear">
						<div className="grid-col-row">
							{formData?.services?.map((service) => {
								return (
									<div
										key={service?.id}
										className="item-example grid-col grid-col-4">
										<div className="rectangle text-center">
											<img
												src={service?.image}
												alt="services"
												style={{ width: "100%", height: "100%" }}
											/>
										</div>
										<h3>{service?.title}</h3>
										<div className="line"></div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
				<hr />

				<section id="portfolio" className="portfolio padding-section">
					<div className="grid-row">
						<div className="portfolio-filter clear">
							<div className="title d-flex justify-content-between">
								<div>
									<span className="main-title">PORTFOLIO</span>
									<span className="slash-icon">/</span>
									<br />
									<span data-filter=".photo">PHOTGRAPHY</span>
									<span className="slash-icon">/</span>
									<span data-filter=".design">DESIGN</span>
									<span className="slash-icon">/</span> <br />
									<span data-filter=".video">VIDEO</span>
									<span className="slash-icon">/</span>
									<span data-filter=".web">WEB</span>
									<span className="slash-icon">/</span>
									<span data-filter=".music">MUSIC</span>
								</div>
								<p className="all-iso-item active" data-filter=".item">
									ALL
								</p>
							</div>
						</div>
					</div>
					<div className="isotope">
						{formData?.our_partners?.map((part) => {
							return (
								<div className="item design photo video web ">
									<div className="portfolio-hover">
										<div className="portfolio-info">
											<div className="portfolio-title">Future timeline</div>
											<div className="portfolio-divider"></div>
										</div>
									</div>
									<img src={part.image} alt="partners" />
								</div>
							);
						})}
				*** <div className="item design photo video web ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Future timeline</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Photography, Art</div>
					</div>
				</div>
				<img src={images.iso1} alt="image" />
			</div>
			<div className="item illust video ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Sit Amet</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Video, Art</div>
					</div>
				</div>
				<img src={images.iso3} alt="image" />
			</div>
			<div className="item design illust photo web ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Sed Laoreete</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Video, Photography</div>
					</div>
				</div>
				<img src={images.iso5} alt="image" />
			</div>
			<div className="item illust photo ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Amet Interdum</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Music, Art</div>
					</div>
				</div>
				<img src={images.iso8} alt="image" />
			</div>
			<div className="item design video web ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Cras varius</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Photography, Art</div>
					</div>
				</div>
				<img src={images.iso10} alt="image" />
			</div>
			<div className="item illust photo video ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Maecenas Semper</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Business, Art</div>
					</div>
				</div>
				<img src={images.iso2} alt="image" />
			</div>
			<div className="item illust video web music ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Scelerisque Venen</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Music, Art</div>
					</div>
				</div>
				<img src={images.iso6} alt="image" />
			</div>
			<div className="item design photo music ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Libero Luctus</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Music, Art</div>
					</div>
				</div>
				<img src={images.iso9} alt="image" />
			</div>
			<div className="item photo web music ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Dlandit Cursus</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Business, Art</div>
					</div>
				</div>
				<img src={images.iso4} alt="image" />
			</div>
			<div className="item photo video web music ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Future timeline</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Music, Photography</div>
					</div>
				</div>
				<img src={images.iso7} alt="image" />
			</div>
			<div className="item design video music ">
				<div className="portfolio-hover">
					<div className="portfolio-info">
						<a href=""><div className="portfolio-title">Sed Tempor</div></a>
						<div className="portfolio-divider"></div>
						<div className="portfolio-description">Business, Art</div>
					</div>
				</div>
				<img src={images.iso11} alt="image" />
			</div> ***
					</div>
				</section>
			*/}
			</div>
		</>
	);
};
export default Branding;
